import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import NavBar from 'components/NavBar';
import NEOVARSITY_MANAGEMENT_SIDEBAR_DATA from 'data/neoVarsityManagementSidebarData.js';
import styles from './NeovarsityManagementSidebar.module.scss';
import WithPermissions from 'components/WithPermissions';

export default function NeovarsityManagementSidebar() {
  return (
    <>
      <NavBar
        title="NEOVARSITY MANAGEMENT TOOL"
        className="p-xs"
        id="neovarsity-management-sidebar"
      />
      <ElementSpacePlaceholder elementId="neovarsity-management-sidebar" />
      <div className={styles.root}>
        {NEOVARSITY_MANAGEMENT_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={`neovarsity-management-sidebar-${sectionIndex}`}
          >
            <div
              className={classNames('bold', 'dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={`neovarsity-management-tabs-${tabIndex}`}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
